import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import ErasureRequestsList from './ErasureRequestsList';
export default class ErasureRequestsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.history.push('erasure-requests');
    app.erasureRequests.load();
    this.bodyClass = 'App--ErasureRequests';
  }
  view() {
    return m("div", {
      className: "ErasureRequestsPage"
    }, m(ErasureRequestsList, {
      state: app.erasureRequests
    }));
  }
}
flarum.reg.add('flarum-gdpr', 'forum/components/ErasureRequestsPage', ErasureRequestsPage);